// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4s-1";
export var standaloneTable = "_4s-0";